module.exports = __webpack_public_path__ + "img/box.ee9f8f4a.png";